angular
	.module 'App.Directive'
	.directive 'clearOnEmpty', ($compile, parseBool) ->
		restrict: 'A'
		require: 'ngModel'
		link: (scope, element, attr, ngModel) ->
			ngModel.$parsers.push (value) ->
				if value == '' && (attr.clearOnEmpty == '' || parseBool(attr.clearOnEmpty))
					return null

				return value
